<section #host class="slogan" [class.slogan-shown]="shown()">
  <div class="slogan-eyebrow">
    <span class="slogan-dot"></span>
    {{ 'slogan.eyebrow' | translate }}
  </div>
  <div ppcHeading class="slogan-lines">
    @for (line of viewLines(); track $index) {
      <span
        class="slogan-line"
        [class.slogan-line-last]="line.last"
        [style.animation-delay.ms]="line.delayMs">
        @for (segment of line.segments; track $index) {
          <span [class.slogan-segment-colored]="segment.colored">{{ segment.text }}</span>
        }
      </span>
    }
  </div>
  <div class="slogan-rule"></div>
  <button ppcButton size="lg" type="button" class="slogan-action" (click)="joinClick.emit()">
    <span>{{ 'hero.cta' | translate }}</span>
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" aria-hidden="true">
      <path d="M1 7H15M15 7L9 1M15 7L9 13" stroke="currentColor" stroke-width="1.6" />
    </svg>
  </button>
</section>
